import React from "react";

export default function PropertyThumbnailGallery(props) {
  return <div>PropertyThumbnailGallery</div>
}
